
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#d20311"},attrs:{"d":"M49,0H15C6.72,0,0,6.72,0,15v34c0,8.28,6.72,15,15,15h34c8.28,0,15-6.72,15-15V15c0-8.28-6.72-15-15-15ZM34.79,40.94c-2.36,0-4.58-1.23-5.34-2.67,0,0-1.17,4.45-1.45,5.54-.53,2.02-2.86,5.99-4.3,7.2l-.18-1.65c-.2-1.84-.39-4.68.08-6.69.42-1.82,2.73-11.58,2.73-11.58,0,0-.7-1.4-.7-3.46,0-3.24,1.88-5.66,4.21-5.66,1.99,0,2.95,1.49,2.95,3.28,0,2-1.27,4.99-1.93,7.75-.55,2.32,1.16,4.21,3.45,4.21,4.14,0,7.32-4.36,7.32-10.67,0-5.58-4.01-9.48-9.73-9.48-6.63,0-10.52,4.97-10.52,10.11,0,2,.77,4.15,1.73,5.32.19.23.22.43.16.67-.18.74-.57,2.32-.65,2.64-.1.43-.34.52-.78.31-2.91-1.35-4.73-5.61-4.73-9.02,0-7.35,5.34-14.09,15.39-14.09,8.08,0,14.36,5.76,14.36,13.45,0,8.03-5.06,14.49-12.09,14.49Z"}})])
          )
        }
      }
    